import { MainColor } from '../../palette/colors';
import { WorkerEventCalendarType } from '@nexelem/api';

export const getCalendarThemeConfig = () => {
  const dueDateEvent = {
    backgroundColor: 'rose10' as MainColor,
    borderColor: 'rose20' as MainColor,
    labelColor: 'rose50' as MainColor,
    counterColor: 'coolGrey80' as MainColor,
    indicator: {
      fill: 'rose50' as MainColor,
      stroke: 'rose60' as MainColor,
    },
  };
  return {
    headerBorderBottom: 'coolGrey30' as MainColor,
    rowBorderTop: 'coolGrey10' as MainColor,
    rowBorderLeft: 'coolGrey10' as MainColor,
    currentColor: 'forest50' as MainColor,
    dayOffRangeColor: 'coolGrey50' as MainColor,
    eventsTypes: {
      [WorkerEventCalendarType.WorkReport]: {
        backgroundColor: 'coolGrey10' as MainColor,
        borderColor: 'coolGrey20' as MainColor,
        labelColor: 'navy50' as MainColor,
        counterColor: 'coolGrey80' as MainColor,
        indicator: {
          fill: 'navy50' as MainColor,
          stroke: 'navy60' as MainColor,
        },
      },
      [WorkerEventCalendarType.WorkerAnnualLeave]: {
        backgroundColor: 'yellow10' as MainColor,
        borderColor: 'yellow20' as MainColor,
        labelColor: 'yellow50' as MainColor,
        counterColor: 'coolGrey80' as MainColor,
        indicator: {
          fill: 'yellow30' as MainColor,
          stroke: 'yellow50' as MainColor,
        },
      },
      [WorkerEventCalendarType.WorkerSickLeave]: {
        backgroundColor: 'violet10' as MainColor,
        borderColor: 'violet20' as MainColor,
        labelColor: 'violet50' as MainColor,
        counterColor: 'coolGrey80' as MainColor,
        indicator: {
          fill: 'violet50' as MainColor,
          stroke: 'violet60' as MainColor,
        },
      },
      [WorkerEventCalendarType.WorkerCompetenceDueDate]: dueDateEvent,
      [WorkerEventCalendarType.WorkerDocumentDueDate]: dueDateEvent,
    },
  };
};

export type CalendarTheme = ReturnType<typeof getCalendarThemeConfig>;
